import { render, staticRenderFns } from "./SwifterStruct.vue?vue&type=template&id=681593ab&scoped=true"
import script from "./SwifterStruct.vue?vue&type=script&lang=js"
export * from "./SwifterStruct.vue?vue&type=script&lang=js"
import style0 from "./SwifterStruct.vue?vue&type=style&index=0&id=681593ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681593ab",
  null
  
)

export default component.exports